export default __webpack_public_path__ + "static/media/wrapper-media1.78bc3ab8.jpg";